import { Box } from "@mui/material"
import React from "react"
import { Agent } from "../../types/Agent"
import { CallSpinner } from "../CallChrome/CallSpinner"
import { CallShell } from "../layout/CallShell"

interface CallLoadingProps {
  agent?: Agent
  isEmbed?: boolean
}

export default function CallLoading({
  agent,
  isEmbed = false,
}: CallLoadingProps) {
  return (
    <CallShell isEmbed={isEmbed}>
      <Box
        data-testid="call-loading"
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--spacing-tokens-size-in-px-spacing-spacing-lg)",
          textAlign: "center",
          padding: "var(--spacing-tokens-size-in-px-spacing-spacing-3xl)",
          backgroundColor: "var(--call-scrim)",
        }}
      >
        <CallSpinner />
        <Box
          sx={{
            maxWidth: "600px",
            fontFamily: "var(--app-font-family, figtree, sans-serif)",
            fontSize: {
              xs: "var(--global-heading-s-medium-font-size)",
              sm: "var(--global-heading-l-medium-font-size)",
            },
            fontWeight: "var(--global-heading-l-medium-font-weight)",
            lineHeight:
              "calc(var(--global-heading-l-medium-line-height) * 1px)",
            color: "var(--color-text-text-white)",
          }}
        >
          {agent?.name || "Your agent"} is joining.
          <br />
          This may take a moment…
        </Box>
      </Box>
    </CallShell>
  )
}
